import { DataAmigavel } from '@/shared/utils/datas';
import { Document, Page, Text, View } from '@react-pdf/renderer';
import { stylesDefensoresLotacao } from './styles/defensores-lotacao.style';
import { IFullReport, IReportLotacao } from '@/api.types';

interface IProps {
  relatorio: IFullReport;
  exibirAnotacoes: boolean;
  exibirTudo: boolean;
  agruparDefensoria: boolean;
}

function TipoLotacaoExtenso(tipo: number): string {
  const tipos: Record<number, string> = {
    1: '[T]',
    2: '[S]',
    3: '[A]',
    4: '[C]',
  };
  return tipos[tipo] || '[?]';
}

function ExibirData(lotacao: IReportLotacao): string {
  const ini = lotacao.data_inicial ? `desde ${DataAmigavel(lotacao.data_inicial)}` : '';
  const fim = lotacao.data_final ? ` até ${DataAmigavel(lotacao.data_final)}` : '';
  return ini || fim ? ` (${ini}${fim})` : '';
}

// function ExibirDataSubst(sub: IReportSubstituicao, todas: IReportSubstituicao[], agrupar: boolean): string {
//   if (!sub) return '';

//   if (agrupar) {
//     const semelhantes = todas.filter(
//       (s) =>
//         s.defensoria_id === sub.defensoria_id &&
//         s.defensor_id === sub.defensor_id &&
//         s !== sub,
//     );
//     if (semelhantes.length > 0) {
//       return ` (diversos períodos em ${semelhantes.length + 1} registros)`;
//     }
//   }

//   return sub.anotacao ? ` (${sub.anotacao})` : '';
// }

export default function DefensorPorLotacao({ relatorio, exibirAnotacoes, exibirTudo }: IProps) {
  const pessoas = relatorio.pessoas ?? [];
  const lotacoes = relatorio.lotacoes ?? [];
  //const substituicoes = relatorio.substituicoes ?? [];
  const defensorias = relatorio.comarcas.flatMap(c => c.locais);

  const defensores = [...pessoas]
    .filter((d) =>
      lotacoes.some((l) => l.defensor_id === d.id)
      // || substituicoes.some((s) => s.defensor_id === d.id)
    )
    .sort((a, b) => a.nome.localeCompare(b.nome));

  const agora = new Date();
  const dataHora = `${DataAmigavel(agora)} às ${agora.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })}`;

  return (
    <Document>
      <Page size="A4" style={stylesDefensoresLotacao.page} orientation="portrait">
        <Text style={stylesDefensoresLotacao.title}>Tabela simplificada de lotações dos defensores</Text>
        <View style={stylesDefensoresLotacao.table}>
          <View style={[stylesDefensoresLotacao.tableRow, stylesDefensoresLotacao.tableCellHeader]}>
            <Text style={stylesDefensoresLotacao.tableColNome}>Nome</Text>
            <Text style={stylesDefensoresLotacao.tableColAtuacoes}>Atuações Vigentes</Text>
          </View>
          {defensores.map((defensor, index) => {
            const minhasLotacoes = lotacoes.filter((l) => l.defensor_id === defensor.id && (exibirTudo || l.ativo));
            //const minhasSubstituicoes = substituicoes.filter((s) => s.defensor_id === defensor.id);
            // const minhasSubstituicoesFiltradas = agruparDefensoria
            //   ? minhasSubstituicoes.filter(
            //     (value, idx, array) =>
            //       idx === array.findIndex((item) => item.defensoria_id === value.defensoria_id),
            //   )
            //   : minhasSubstituicoes;

            return (
              <View
                key={defensor.id}
                style={[stylesDefensoresLotacao.tableRow, index % 2 === 0 ? stylesDefensoresLotacao.tableRowOdd : stylesDefensoresLotacao.tableRowEven]}
                wrap={false}
              >
                <View style={stylesDefensoresLotacao.tableColNome}>
                  <Text>{defensor.nome}</Text>
                </View>
                <View style={stylesDefensoresLotacao.tableColAtuacoes}>
                  {minhasLotacoes.map((lot, i) => {
                    const defensoria = defensorias.find(d => d.id === lot.defensoria_id);
                    //const nucleo = relatorio.nucleos.find(n => n.id === lot.nucleo_id);
                    const parts = [
                      TipoLotacaoExtenso(lot.tipo),
                      defensoria?.nome,
                      //nucleo?.nome,
                      ExibirData(lot)
                    ].filter(part => part); // Remove undefined or empty strings
                    return (
                      <Text key={i} style={stylesDefensoresLotacao.textLine}>
                        {parts.join(' ')}
                        {exibirAnotacoes && (lot.anotacao1 || lot.anotacao2) && (
                          <Text style={stylesDefensoresLotacao.small}> - {lot.anotacao1} {lot.anotacao2}</Text>
                        )}
                      </Text>
                    );
                  })}
                  {/* {minhasSubstituicoesFiltradas.map((sub, i) => {
                    const defensoria = defensorias.find(d => d.id === sub.defensoria_id);
                    return (
                      <Text key={`sub-${i}`} style={stylesDefensoresLotacao.muted}>
                        [S] {defensoria?.nome ?? ''}{ExibirDataSubst(sub, minhasSubstituicoes, agruparDefensoria)}
                      </Text>
                    );
                  })} */}
                </View>
              </View>
            );
          })}
        </View>
        <Text style={stylesDefensoresLotacao.footer}>Emitido em: {dataHora}</Text>
      </Page>
    </Document>
  );
}